import { render, staticRenderFns } from "./sales-awaiting-list.vue?vue&type=template&id=723bd09c"
import script from "./sales-awaiting-list.vue?vue&type=script&lang=js"
export * from "./sales-awaiting-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports